import { CONSTANTS } from "../constants/app-constant";

// A QLink question names its exam; a visitor who signs up from it should not
// have to find that exam again in the mandatory exam picker. The exam travels
// from the question page to /create-quiz as ROUTER LOCATION STATE: ephemeral,
// per-navigation, nothing persisted (same pattern as weak-area-prefill.js).
export const QLINK_SEED_EXAM_STATE_KEY = "qlinkSeedExam";

const examTypeEntries = () => CONSTANTS.examTypeList || [];

// The single exam a question's categories name, as its display name
// ("ABSITE", "Step 2"), or "" when there are none, several, or an unknown one.
// The bank stores ExamType display strings ("Step 2", "ABR Core") while
// examTypeList keys on enum names ("Step_2"), so match either, then count
// distinct exams (not distinct spellings).
export const resolveQlinkExamLabel = (examTypes) => {
  const names = Array.isArray(examTypes)
    ? [...new Set(examTypes.filter(Boolean).map((raw) => examTypeEntries()
      .find((exam) => exam.value === raw || exam.name === raw)?.name || `unknown:${raw}`))]
    : [];
  return names.length === 1 && !names[0].startsWith("unknown:") ? names[0] : "";
};

// Router state for the QLink exits to /create-quiz, or undefined (no exam).
export const buildQlinkPracticeState = (examLabel) =>
  examLabel ? { [QLINK_SEED_EXAM_STATE_KEY]: examLabel } : undefined;

// The exam-type string, from the list the categories endpoint returned, that
// the seed names; "" when the seed is missing or the list does not offer it.
// A stale or forged seed can therefore never select an exam that is not offered.
export const resolveSeedExamType = (seed, examTypeList) => {
  if (typeof seed !== "string" || !seed.trim() || !Array.isArray(examTypeList)) {
    return "";
  }
  const entry = examTypeEntries().find((exam) => exam.name === seed || exam.value === seed);
  const spellings = entry ? [entry.value, entry.name] : [seed];
  return spellings.find((spelling) => examTypeList.includes(spelling)) || "";
};
